import { render } from "./UserAvatar.vue?vue&type=template&id=2320b49e&ts=true"
import script from "./UserAvatar.vue?vue&type=script&lang=ts"
export * from "./UserAvatar.vue?vue&type=script&lang=ts"

import "./UserAvatar.vue?vue&type=style&index=0&id=2320b49e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__